import React from 'react';
import { Alert, Button } from '@mui/material';

interface AvisoDeFalhaAoCarregarProps {
  mensagem: string;
  rotuloDoBotao: string;
  aoVoltar: () => void;
}

/** O aviso que substitui a tela quando o registro não abre, com a saída de volta para a lista. */
export const AvisoDeFalhaAoCarregar: React.FC<AvisoDeFalhaAoCarregarProps> = ({
  mensagem,
  rotuloDoBotao,
  aoVoltar,
}) => (
  <Alert
    severity="error"
    action={
      <Button color="inherit" size="small" onClick={aoVoltar}>
        {rotuloDoBotao}
      </Button>
    }
  >
    {mensagem}
  </Alert>
);
